<template>
    <!-- Page Content -->
    <div class="d-lg-flex half">
        <div class="bg order-1 order-md-2"></div>
        <div class="contents order-2 order-md-1">
            <div class="container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-md-7 py-4">
                        <div class="text-center mb-4">
                            <a :href="$router.resolve({ name: 'home' }).href" class="navbar-brand logo mr-0">
                                <img src="@/assets/img/logo.png" class="img-fluid" alt="Logo">
                            </a>
                        </div>
                        <!-- <h3>Je me connecte</h3> -->
                        <!-- <p class="mb-4">Sapiente sit aut eos consectetur adipisicing.</p> -->
                        <form @submit.prevent="login">
                            <div class="form-group card-label h-100 mb-3">
                                <label class="bg-light">E-mail</label>
                                <input type="text" id="email" class="form-control floating" v-model="email">
                            </div>
                            <div class="form-group card-label h-100 mb-3">
                                <label class="bg-light">Mot de Passe</label>
                                <input type="password" id="password" class="form-control floating" v-model="password">
                            </div>
                            <div class="text-right">
                                <a class="forgot-link" :href="$router.resolve({ name: 'ForgotPassword' }).href">Mot de passe oublié ?</a>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary btn-block btn-lg login-btn btn-rounded" type="submit">
                                    <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                                    <label class="m-0 mx-1">Se connecter</label>
                                </button>
                            </div>
                            <div class="login-or">
                                <span class="or-line"></span>
                                <span class="span-or">ou</span>
                            </div>
                            <div class="row form-row social-login">
                                <div class="col-6">
                                    <a :href="'#'" class="btn btn-facebook btn-block btn-rounded" :disabled="true" @click.prevent="socialLogin('facebook')">
                                        <i class="fab fa-facebook-f mr-1"></i> Continuer avec Facebook
                                    </a>
                                </div>
                                <div class="col-6">
                                    <a href="#" class="btn btn-google btn-block btn-rounded" @click.prevent="socialLogin('google')">
                                        <i class="fab fa-google mr-1"></i> Continuer avec Google</a>
                                </div>
                            </div>
                            <div class="text-center dont-have mb-3">
                                Tu n'a encore pas de compte ?
                                <a :href="$router.resolve({ name: 'register' }).href"><b>S'inscrire</b></a>
                                <!-- <a href="/register" class="btn btn-secondary btn-block btn-rounded mt-1">S'inscrire</a> -->
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /Page Content -->
</template>
<script>
import vSelect from "vue-select";
import { api } from '@/store';  // Import axios from your store

import "vue-select/dist/vue-select.css";

export default {
    components: {
        vSelect
    },
    data() {
        return {
            email: '',
            password: '',
        }
    },
    computed: {
        errorMessages() {
            return this.$store.getters.errorMessages;
        },
        error() {
            return this.$store.getters.error;
        }
    },
    created() {
        this.getDelegations()
    },
    methods: {
        getDelegations() {
            api.get('/core/static/regions/delegations')
                .then(response => {
                    const result = response.data
                    this.delegations = result.filter(Boolean)
                })
        },
        async login() {
            this.clearForm();
            let payload = { email: this.email, password: this.password };
            if (this.$route.query.redirect) {
                payload.redirectTo = this.$route.query.redirect;
            }
            $('.submit-section button').attr('disabled', 'disabled')
            $('.submit-section button span').removeClass('d-none')
            await this.$store.dispatch('login', payload);
            $('.submit-section button').removeAttr('disabled')
            $('.submit-section button span').addClass('d-none')
            if (Object.keys(this.errorMessages).length > 0 || this.error) {
                const inputs = $("#email, #password");
                inputs.each(function () {
                    const $input = $(this);
                    $input.addClass('is-invalid');
                    $input.closest('.form-group').find('.invalid-feedback').remove(); // Remove any existing feedback messages
                    $input.closest('.form-group').append(
                        '<span class="invalid-feedback mt-0" role="alert">E-mail/Mot de passe erronés</span>'
                    );
                });

            }
        },
        async socialLogin(provider) {
            this.clearForm();
            try {
                // Make request to your FastAPI backend to initiate social login
                const response = await api.get(`/auth/${provider}/authorize`);

                // Redirect to the URL returned by FastAPI, which initiates social login process
                window.location.href = response.data.authorization_url;
            } catch (error) {
                $('.social-login').append(
                    '<span class="invalid-feedback d-block mt-0 pl-1" role="alert">' + error.response.data.error + '</span>'
                );
                console.error('Login error via social network:', error.response.data.error);
            }
        },
        clearForm() {
            $('.invalid-feedback').remove();
            $('.form-control.is-invalid').removeClass('is-invalid');
        }
    },
    watch: {
        '$store.state.error'(newValue) {
            // console.log('errors changed to:', newValue);
            this.error = newValue;
        }
    }
}
</script>
